import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function getDownloadCredentialRequest(credential: string) {
	return await apiClient
		.get(API.QUERY.ADMIN.DOWNLOAD_CREDENTIAL(credential), {
			headers: { "Content-Type": "application/zip" },
			responseType: "blob"
		})
		.then((res) => res.data);
}
